import { get_token } from "@/router";
import Loader from "@/components/Loader/LoaderView";
import portal_form_helper from "./portal_form_helper";

export default {
  components: {
    Loader,
  },
  watch: {
    '$route.params.portal_id': {
      handler(newPortalId) {
        if (!newPortalId) {
          this.portal_forms = [];
          this.form_answers = {};
          this.form_files = {};
          this.form_errors = {};
          this.submitted_form_ids = {};
          this.expanded_form_id = null;
          return;
        }

        this.form_answers = {};
        this.form_files = {};
        this.form_errors = {};
        this.submitted_form_ids = {};
        this.expanded_form_id = null;
        this.get_portal_forms(newPortalId);
      },
      immediate: true
    },
  },
  data() {
    return ({
        portal_forms: [],
        loading_portal_forms: false,
        form_answers: {},
        form_files: {},
        form_errors: {},
        submitting_forms: {},
        expanded_form_id: null,
        submitted_form_ids: {},
    })
   },
   computed: {
        portal_id(){
            return this.$route.params.portal_id;
        },
   },
   methods: {
       ...portal_form_helper,
       getToken() {
         return get_token();
        },
        parse_stored_profile(key) {

              return JSON.parse(localStorage.getItem(key) || "null");
        },
        get_active_profile() {
            const storage_keys = ["activeProfile", "active_profile", "base_profile", "activeBaseProfile"];

            for (const key of storage_keys) {
              const stored_profile = this.parse_stored_profile(key);
              if (stored_profile) {
                return stored_profile;
              }
            }

            return null;
        },
        get_active_base_profile_id() {
            return this.get_active_profile()?.id || null;
        },
        toggle_form(form_id) {
            this.expanded_form_id = this.expanded_form_id === form_id ? null : form_id;
        },
        is_form_open(form_id) {
            return this.expanded_form_id === form_id;
        },
        get_form_sections(formItem) {
            return formItem?.form?.form_sections || [];
        },
        get_form_questions(formItem) {
            return this.get_form_sections(formItem).flatMap((sectionEntry) => sectionEntry?.section?.question_sections || []);
        },
        get_form_question_count(formItem) {
            return this.get_form_sections(formItem).reduce((count, sectionEntry) => {
              const question_count = sectionEntry?.section?.question_sections?.length || 0;
              return count + question_count;
            }, 0);
        },
        get_assigned_portals_text(formItem) {
            const assigned_portals = formItem?.form?.assigned_portals || [];
            return assigned_portals.map((portal) => portal?.name).filter(Boolean).join(', ');
        },
        format_date(value) {
            if (!value) return '';

            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
              return '';
            }

            return date.toLocaleDateString('en-ZA', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
            });
        },
        truncate_text(value, maxLength = 60) {
            const text = String(value || '').trim();

            if (!text || text.length <= maxLength) {
              return text;
            }

            return `${text.slice(0, maxLength)}...`;
        },
        get_question_type(questionSection) {
            return questionSection?.question?.question_type?.question_type || 'text';
        },
        get_question_options(questionSection) {
            return questionSection?.question?.options || [];
        },
        get_question_value(question_id) {
            return Reflect.get(this.form_answers, question_id) ?? '';
        },
        set_question_value(question_id, value) {
            this.form_answers = {
              ...this.form_answers,
              [question_id]: value,
            };

            if (Reflect.get(this.form_errors, question_id)) {
              this.form_errors = {
                ...this.form_errors,
                [question_id]: '',
              };
            }
        },
        toggle_checkbox_answer(question_id, optionValue, isChecked) {
            const current_value = this.get_question_value(question_id);
            const values = Array.isArray(current_value) ? [...current_value] : [];

            if (isChecked) {
              if (!values.includes(optionValue)) {
                values.push(optionValue);
              }
            } else {
              const next_values = values.filter((value) => value !== optionValue);
              this.set_question_value(question_id, next_values);
              return;
            }

            this.set_question_value(question_id, values);
        },
        handle_file_upload(event, question_id) {
            const file = event?.target?.files?.[0] || null;

            this.form_files = {
              ...this.form_files,
              [question_id]: file,
            };

            this.set_question_value(question_id, file?.name || '');
        },
        get_selected_file_name(question_id) {
            return Reflect.get(this.form_files, question_id)?.name || '';
        },
        is_question_required(questionSection) {
            return questionSection?.question?.is_mandatory === true;
        },
        get_question_error(question_id) {
            return Reflect.get(this.form_errors, question_id) || '';
        },
        is_form_submitting(form_id) {
            return Reflect.get(this.submitting_forms, form_id) === true;
        },
        is_form_submitted(form_id) {
            return Reflect.get(this.submitted_form_ids, form_id) === true;
        },
        is_form_locked(formItem) {
            const form_id = formItem?.form?.id || formItem?.id;
            return this.is_form_submitted(form_id);
        },
        hydrate_form_answers(forms) {
            const next_answers  = {};
            const next_submitted_ids = {};

            (forms || []).forEach((formItem) => {
              this.hydrate_form_item_answers(formItem, next_answers, next_submitted_ids);
            });

            this.form_answers = next_answers ;
            this.submitted_form_ids = next_submitted_ids;
        },
        validate_portal_form(formItem) {
            const next_errors = {};
            let hasErrors = false;

            this.get_form_questions(formItem).forEach((questionSection) => {
              if (this.has_required_question_error(questionSection)) {
                const question_id = this.get_question_section_id(questionSection);
                hasErrors = true;
                Reflect.set(next_errors, question_id, 'This field is required.');
              }
            });

            this.form_errors = next_errors;
            return !hasErrors;
        },
        build_form_answers_payload(formItem, formData) {
            return this.get_form_questions(formItem).reduce((answers, questionSection) => {
              return this.add_question_answer_payload(answers, questionSection, formData);
            }, []);
        },
        submit_portal_form(formItem) {
            const form_id = this.get_form_id(formItem);
            const base_profile_id = this.get_active_base_profile_id();

            if (!this.can_submit_portal_form(formItem, base_profile_id)) {
              return;
            }

            const form_data = this.build_portal_form_data(formItem, base_profile_id);
            this.set_form_submitting(form_id, true);
            this.post_portal_form(form_data, form_id);
        },
        get_portal_forms(portalId = this.portal_id){
            if (!portalId) {
              this.portal_forms = [];
              return;
            }

            this.loading_portal_forms = true;
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_forms/`,
                method: "POST",
                data: JSON.stringify({ portal_id: portalId }),
                headers: {
                "Authorization": `Token ${this.getToken()}`,
                "Content-Type": "application/json"
                },
                success: (response) => {
                  this.handle_portal_forms_success(response);
                },
                error: (xhr) => {
                this.portal_forms = [];
                console.error("Error fetching portal forms:", xhr);
                },
                complete: () => {
                  this.loading_portal_forms = false;
                }
            })
        }
    }


}
